import {
    Box,
    Paper,
    Stack
} from '@mantine/core';
import {AccountApplicationLogo} from "../images/AccountApplicationLogo.tsx";
import {Application} from "../types.ts";

export const AccountApplicationGridProfile = ({cloudApplication}: {
    cloudApplication: Application & { linkFragment: string }
}) => {

    // const {recordAppExit} = useAnalytics();

    const handleClick = async () => {

        // recordAppExit(cloudApplication);


        const appLink = cloudApplication.url as string;
        const linkFragment = cloudApplication.linkFragment as string;

        const linkUrl = [appLink, linkFragment].join('/');
        window.open(linkUrl);


    };


    return (
        <Paper onClick={handleClick} m={'sm'} shadow={'sm'}>
            <Stack align="center">
                <Box mt="1em" style={{height: '8em'}}>
                    <AccountApplicationLogo record={cloudApplication}/>
                </Box>

                <Box
                    style={{
                        textAlign: 'center',
                        inlineSize: '90%',
                        overflowWrap: 'break-word',
                    }}
                >
                    {cloudApplication.name}
                </Box>

            </Stack>
        </Paper>
    );
};
